import Detections from './Detections'
import PrivilegedDetections from './PrivilegedDetections'
import TrailDetections from './TrailDetections'
import AccountKeyDetections from './AccountKeyDetections'

export { Detections, PrivilegedDetections, TrailDetections, AccountKeyDetections }



// WEBPACK FOOTER //
// ./src/views/detections/index.js